import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
// Services
import { LayoutRenderService } from './services/layout-render.service';
// Models
import { CvLayoutRenderModel } from './models/cv-layout-render.model';
import { LayoutDictionary } from './models/layout-dictionary';
import { UIConfigComponent, UIConfigService, UIConfigStyle } from '@cv-invision/core';

@Component({
	selector: 'cv-layout-render',
	templateUrl: './cv-layout-render.component.html',
	styleUrls: ['./cv-layout-render.component.scss']
})
export class CvLayoutRenderComponent implements OnInit, OnDestroy, OnChanges {
	@Input() data: CvLayoutRenderModel;

	// Current Layout Set Up
	public layout: any;

	constructor(
		private layoutService: LayoutRenderService,
		private uiConfigService: UIConfigService) {
	}

	ngOnInit(): void {
		this.layoutService.setSubjects();
		const schemaData = LayoutDictionary.generateLayoutDictionary(this.data.schema);
		this.layoutService.setSchema(schemaData);
		this.layoutService.setExtraData(this.data.extraData);
		this.layout = this.layoutService.layout;
		// UI Config
		this.loadUIConfig();
	}

	/**
	 * Load the Configuration and apply rules if exist on the Config
	 * @private
	 */
	private loadUIConfig(): void {
		const orderViewStyle: UIConfigStyle = this.uiConfigService.getComponentStyle(UIConfigComponent.ORDER_VIEW);

		if (orderViewStyle) {
			// Copy styles if model exists
			if (this.layoutService.layout) {
				if (orderViewStyle.section) {
					this.layoutService.layout.uiConfig = orderViewStyle;
				}
			}
		}
	}

	ngOnDestroy(): void {
		this.layoutService.componentBroadcast.complete();
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (!changes.data.firstChange) {
			this.layoutService.setExtraData(changes.data.currentValue.extraData);
		}
	}
}
